import type { Endpoint } from '@reckon-web/rest-api-client';
import { useQuery } from '@reckon-web/rest-api-client';

import type { PortalRestApi } from '../../../services/PortalRestApi';
import { useFetchClient } from '../../../services/PortalRestApi';

export type GetUserRequest = {};
export type GetUserResponse = {
  result: 'success' | 'error';
  message?: string;
  userid: string;
  firstname: string;
  lastname: string;
  email: string;
  username: string;
  admin: string;
  country: string;
  tenancyid: string;
  expiry: string;
};

export type GetUserErrorResponse = {
  result: 'error';
  message: string;
};

async function getUserRequest(request = {}, restAPI?: PortalRestApi) {
  try {
    const data = await restAPI?.client.get<GetUserResponse>(
      getUserEndpoint.url({}),
      {
        options: {
          requiresAuthentication: true,
        },
      }
    );

    if (data?.result === 'success') {
      return data;
    }

    throw new Error(data?.message);
  } catch (error) {
    throw error;
  }
}

export const useGetUserQuery = () => {
  const fetchClient = useFetchClient();
  return useQuery<GetUserResponse, GetUserErrorResponse>(
    getUserEndpoint.key({}),
    () => {
      return getUserRequest({}, fetchClient);
    }
  );
};

export const getUserEndpoint: Endpoint<GetUserRequest, GetUserResponse> = {
  name: 'GetUserQuery',
  url: () => {
    return `auth/tokenvalidate`;
  },
  key: () => {
    return [getUserEndpoint.name];
  },
  fetch: getUserRequest,
};
